<template>
  <div>
    <van-row class="bmTitle">
      <van-col span="24">
        <h2>团体成员管理</h2>
      </van-col>
    </van-row>
    <van-row class="bmForm" style="height: 68vh;overflow-y: auto;padding-bottom: 100px;">
      <van-col span="24">
		  <div v-if="enteredList">
			<van-empty description="暂无团体成员" v-if="enteredList.length == 0" />
        <van-card v-for="item in enteredList" :key="item.id" v-else style="padding:15px 16px;">
          <template #title>
             <h2 style="text-align: justify; font-size: 16px;margin:0;">{{item.name}} | {{item.phone}} </h2>
          </template>
          <template #desc>
            <p style="font-size: 14px;">报名时间：{{item.crtTime}}</p>
          </template>
		  <!-- 0828 会议注释 -->
		  <template #thumb>
		    <div @click="chm(item)" style="text-align:center">
				<van-icon class="iconfont" class-prefix="icon" name="erweima" size="80" color="#4DB6AC" />
				<p style="color:#666;margin:0;font-size:12px;">获取参会码</p>
				<p></p>
			</div>
		  </template>
		  <!-- 0828 会议注释 结束 -->
          <!-- <template #tags>
            <van-tag type="primary">已支付/经办人支付</van-tag>
          </template> -->
          <template #price>
			  <div style="margin-bottom:10px;">
				<!-- <span style="font-size: 16px;color:#d00;margin-right: 20px;">¥1200</span> -->
				<van-tag v-if="item.payStatus == 1&&(item.refundStatus == 0||item.refundStatus == 3)&&item.transferStatus != 1" style="font-size: 14px;" type="success" round plain>已支付/{{item.whoPay == 1?'参会人支付':'经办人支付'}}</van-tag>
				<van-tag round plain type="warning" style="font-size: 14px;" v-else-if="item.attr4&&item.refundStatus == 1">申请退费审核中</van-tag>
				<van-tag round plain type="danger" style="font-size: 14px;" v-else-if="item.attr4&&item.refundStatus == 2">已退费</van-tag>
				<van-tag round plain type="warning" style="font-size: 14px;" v-else-if="item.attr4&&item.transferStatus == 1">已转赠</van-tag>
				<van-tag round plain type="warning" style="font-size: 14px;" v-else-if="item.transferStatus == 2">转赠票</van-tag>
				<van-tag v-else style="font-size: 14px;" type="danger" round plain v-else-if="meeting.isBmf == 1">未支付</van-tag>
				<van-tag v-else style="font-size: 14px;" type="danger" round plain v-else-if="meeting.isBmf == 0">免费</van-tag>
			  </div>
          </template>
          <template #footer>
			<van-button type="danger" color="#489bee" style="padding:0 10px;" size="mini" @click="look(item)">{{item.payStatus == 1?'查看':'查看'}}</van-button>
            <van-button type="danger" color="#eb5e5e" style="padding:0 10px;" v-if="item.userId != teamOperator.webUserId&&item.payStatus == 0&&item.transferStatus == 0" @click="remove(item)" size="mini">删除</van-button>
			
            <van-button type="warning" color="#61ce89" size="mini" style="padding:0 10px;" @click="xuefen(item)" v-if="(teamOperator.concatPhone == item.phone)||(((item.payStatus == 1&&item.transferStatus != 1&&(item.refundStatus == 0||item.refundStatus == 3))||item.transferStatus == 2)&&(meeting.isScore == 1&&meeting.isBmf == 0))">学分</van-button>
			<!-- :disabled="JSON.parse(item.extendParam).attr2&&!JSON.parse(item.extendParam).attr2.name" -->
			<van-button type="danger" color="#a3d900" style="padding:0 10px;" v-if="item.whoPay == 2&&(item.refundStatus == 0||item.refundStatus == 3)&&item.payStatus == 1&&new Date(meeting.changeDeadline)>new Date()&&item.transferStatus == 0" @click="zhuanzeng(item)" size="mini">转赠</van-button>
			<van-button type="danger" color="#dd6572" style="padding:0 10px;"  v-if="item.whoPay == 2&&(item.refundStatus == 0||item.refundStatus == 3)&&item.payStatus == 1&&item.transferStatus == 0" @click="enteredApplyRefund(item)" size="mini">退费</van-button>
          </template>
		  
        </van-card>
		</div>
		<van-dialog v-model:show="lookShow" @confirm="chrConfirm" :show-confirm-button="false" theme="round-button">
			<template #title >
			  <h4 style="margin:0 0 20px;font-size: 20px;">参会人信息</h4>
			</template>
			<div v-if="lookItem">
			  <van-row class="bmForm"  style="padding-top:0; position: relative;">
			      <van-col span="24" style="height:300px;padding-bottom:50px;overflow-y: auto;">
			        <van-form @submit="onSubmit">
			          <div class="formInput hide"><van-field v-model="lookItem.id"  name="id" label="id" /></div>
			          <div class="formInput hide"><van-field v-model="lookItem.meetingId"  name="meetingId" label="id" /></div>
			          <div class="formInput " v-for="(item, key, index) in formData" v-if="item.isShow * 1 == 1 && item.formType * 1 == 1">
			              <van-field
			                v-model="lookItem[item.shortName]"
			                :name="item.shortName"
			                :ref="item.shortName"
			                :placeholder="`请输入` + item.name"
			                :label="item.name"
			                clearable
			                :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			                :required="JSON.parse(item.defaultValue).rules&&JSON.parse(item.defaultValue).rules.length==0 ? false : true"
			                v-if="item.shortName !== 'phone'&&item.shortName !== 'ReAddress'"
			              />
			              <div v-else-if="item.shortName == 'ReAddress'">
			                <div class="formInput " style="margin:0;">
			                <van-field
			                  readonly
			                  clickable
			                  is-link
			                  :name="item.shortName"
			                  :value="ReAddressValue"
			                  :label="item.name"
			                  :placeholder="`点击选择地区`"
			                  @click="showPickerSsx = true"
			                  :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			                  :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			                />
			                <van-popup v-model="showPickerSsx" position="bottom">
			                  <van-area title="标题" :area-list="areaList" @confirm="confirmFn" @cancel="ReAddressShow = false" />
			                </van-popup>
			                </div>
			                <van-field
			                  v-model="lookItem[item.shortName]"
			                  :name="item.shortName"
			                  :ref="item.shortName"
			                  placeholder="请输入详细地址（涉及疫情防控,非常重要!）"
			                  clearable
			                  :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			                />
			              </div>
			  
			              <van-field
							readonly
			                v-model="lookItem[item.shortName]"
			                :name="item.shortName"
			                :ref="item.shortName"
			                :placeholder="`请输入` + item.name"
			                :label="item.name"
			                clearable
			                maxlength="11"
			                type="tel"
			                :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			                :rules="[{ pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, required: JSON.parse(item.defaultValue).rules[0] !== undefined ? true : false, message: '请输入正确'+ item.name }]"
			                v-else
			              />
			  
			          </div>
			          <div class="formInput " v-for="(item, key, index) in formData" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 1 && item.shortName == 'email'">
			            <van-field
			              v-model="lookItem[item.shortName]"
			              :name="item.shortName"
			              :ref="item.shortName"
			              :placeholder="`请输入` + item.name"
			              :label="item.name"
			              clearable
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			              :rules="[{ pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, required: JSON.parse(item.defaultValue).rules[0] !== undefined ? true : false, message: '请输入正确'+ item.name }]"
			            />
			          </div>
			          <div class="formInput" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 4 && item.shortName == 'isVisit'">
			            <van-field
			              :name="item.shortName"
			              :label="item.name"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            >
			              <template #input>
			                <van-radio-group v-model="isVisit" direction="horizontal">
			                  <van-radio :name="key" :key="index" v-for="(data, key, index) in JSON.parse(item.defaultValue).valueEnum">{{ data.text }}</van-radio>
			                </van-radio-group>
			              </template>
			            </van-field>
			          </div>
			          <div class="formInput" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 4 && item.shortName == 'sex'">
			            <van-field
			              :name="item.shortName"
			              :label="item.name"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            >
			              <template #input>
			                <van-radio-group v-model="sexValue" direction="horizontal">
			                  <van-radio :name="key" :key="index" v-for="(data, key, index) in JSON.parse(item.defaultValue).valueEnum">{{ data.text }}</van-radio>
			                </van-radio-group>
			              </template>
			            </van-field>
			          </div>
			          <div class="formInputs" v-else-if="item.isShow * 1 == 1 && item.shortName == 'isYdjd'">
			            <div class="formInput">
			            <!-- <van-field
			              :name="item.shortName"
			              :label="item.name"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            >
			              <template #input>
			                <van-radio-group v-model="isYdjdValue" direction="horizontal">
			                  <van-radio :name="key" :key="index" v-for="(data, key, index) in JSON.parse(item.defaultValue).valueEnum">{{ data.text }}</van-radio>
			                </van-radio-group>
			              </template>
			            </van-field> -->
			              <van-field
			                readonly
			                clickable
			                :name="item.shortName"
			                :value="isYdjdValue"
			                :label="item.name"
			                :placeholder="`点击选择` + item.name"
			                @click="showPicker_isYdjd = true"
			                :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			                :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			              />
			              <van-popup v-model="showPicker_isYdjd" position="bottom">
			                <van-picker show-toolbar :columns="isYdjdColumns" @confirm="onConfirmIsYdjd" @cancel="showPicker_isYdjd = false" />
			              </van-popup>
			            </div>
			            <div v-if="isYdjdValue=='是'">
			              <div v-for="zItem,index in item.linkage" :key="index">
			                <div class="formInput" v-if="zItem.isShow * 1 == 1 && zItem.formType * 1 == 3 ">
			                  <van-field
			                    readonly
			                    clickable
			                    :name="zItem.shortName"
			                    :value="fangxingValue"
			                    :label="zItem.name"
			                    :placeholder="`点击选择` + zItem.name"
			                    @click="showPickerFangxing = true"
			                    :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			                    :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			                  />
			                  <van-popup v-model="showPickerFangxing" position="bottom">
			                    <van-picker show-toolbar :columns="fangxingColumns" @confirm="onConfirmFangxing" @cancel="showPickerFangxing = false" />
			                  </van-popup>
			                </div>
			                <div class="formInput " v-else-if="zItem.isShow * 1 == 1 && zItem.formType * 1 == 6">
			                  <van-field
			                    readonly
			                    clickable
			                    :name="zItem.shortName"
			                    :value="rzldTime"
			                    :label="zItem.name"
			                    :placeholder="`点击选择` + zItem.name"
			                    @click="showRzld=true"
			                    :rules="[JSON.parse(zItem.defaultValue).rules[0] !== undefined ? JSON.parse(zItem.defaultValue).rules[0] : '']"
			                    :required="JSON.parse(zItem.defaultValue).rules == '' ? false : true"
			                  />
			                    <van-calendar v-model="showRzld" type="range" @confirm="onConfirmRzldDate" :show-confirm="false" :min-date="rzldMinDate" :max-date="rzldMaxDate" />
			                </div>
			              </div>
			  
			            </div>
			          </div>
			  
			  
			          <div class="formInputs" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'zjlx'">
			          <div class="formInput">
			            <van-field
			              readonly
			              clickable
			              :name="item.shortName"
			              :value="zjlxValue"
			              :label="item.name"
			              :placeholder="`点击选择` + item.name"
			              @click="showPickerZjlx = true"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            />
			            <van-popup v-model="showPickerZjlx" position="bottom">
			              <van-picker show-toolbar :columns="zjlxColumns" @confirm="onConfirmZjlx" @cancel="showPickerZjlx = false" />
			            </van-popup>
			            <!-- <van-field
			              :name="item.shortName"
			              :label="item.name"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            >
			              <template #input>
			                <van-radio-group v-model="zjlxValue" direction="horizontal">
			                  <van-radio :name="key" :key="index" v-for="(data, key, index) in JSON.parse(item.defaultValue).valueEnum">{{ data.text }}</van-radio>
			                </van-radio-group>
			              </template>
			            </van-field> -->
			          </div>
			            <div class="formInput" v-if="zjlxValue == '身份证'">
			              <van-field
			                v-model="cardNum"
			                name="cardNum"
			                placeholder="请输入证件号码"
			                label="证件号码"
			                clearable
			                :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			                :rules="[{ pattern: /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[xX])$/, message: '请输入正确身份证号'}]"
			              />
			            </div>
			            <div class="formInput" v-else-if="zjlxValue == '军官证'">
			              <van-field
			                v-model="officer"
			                name="officer"
			                placeholder="请输入证件号码"
			                label="证件号码"
			                clearable
			                :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			                :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			              />
			            </div>
			            <div class="formInput" v-else-if="zjlxValue == '港澳通行证'">
			              <van-field
			                v-model="HKMpass"
			                name="HKMpass"
			                placeholder="请输入证件号码"
			                label="证件号码"
			                clearable
			                :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			                :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			              />
			            </div>
			            <div class="formInput" v-else-if="zjlxValue == '护照'">
			              <van-field
			                v-model="passport"
			                name="passport"
			                placeholder="请输入证件号码"
			                label="证件号码"
			                clearable
			                :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			                :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			              />
			            </div>
			          </div>
			          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'province'">
			            <van-field
			              readonly
			              clickable
			              :name="item.shortName"
			              :value="provinceValue"
			              :label="item.name"
			              :placeholder="`点击选择` + item.name"
			              @click="showPicker = true"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            />
			            <van-popup v-model="showPicker" position="bottom">
			              <van-picker show-toolbar :columns="provinceColumns" @confirm="onConfirmProvince" @cancel="showPicker = false" />
			            </van-popup>
			          </div>
			          <div class="formInput" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'zzmm'">
			            <van-field
			              readonly
			              clickable
			              :name="item.shortName"
			              :value="zzmmValue"
			              :label="item.name"
			              :placeholder="`点击选择` + item.name"
			              @click="showPickerZzmm = true"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            />
			            <van-popup v-model="showPickerZzmm" position="bottom">
			              <van-picker show-toolbar :columns="zzmmColumns" @confirm="onConfirmZzmm" @cancel="showPickerZzmm = false" />
			            </van-popup>
			          </div>
			          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'nation'">
			            <van-field
			              readonly
			              clickable
			              :name="item.shortName"
			              :value="nationValue"
			              :label="item.name"
			              :placeholder="`点击选择` + item.name"
			              @click="showPickerNation = true"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            />
			            <van-popup v-model="showPickerNation" position="bottom">
			              <van-picker show-toolbar :columns="nationColumns" @confirm="onConfirmNation" @cancel="showPickerNation = false" />
			            </van-popup>
			          </div>
			          <div class="formInput" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'education'">
			            <van-field
			              readonly
			              clickable
			              :name="item.shortName"
			              :value="educationValue"
			              :label="item.name"
			              :placeholder="`点击选择` + item.name"
			              @click="showPickerEducation = true"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            />
			            <van-popup v-model="showPickerEducation" position="bottom">
			              <van-picker show-toolbar :columns="educationColumns" @confirm="onConfirmEducation" @cancel="showPickerEducation = false" />
			            </van-popup>
			          </div>
			          <div class="formInput" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'shens'">
			            <van-field
			              readonly
			              clickable
			              :name="item.shortName"
			              :value="shensValue"
			              :label="item.name"
			              :placeholder="`点击选择` + item.name"
			              @click="showPickerShens = true"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            />
			            <van-popup v-model="showPickerShens" position="bottom">
			              <van-area title="标题" :area-list="areaList" :columns-num="2" @confirm="onConfirmShens" @cancel="showPickerShens = false" />
			            </van-popup>
			          </div>
			          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 3 && item.shortName == 'ssjg'">
			            <van-field
			              readonly
			              clickable
			              :name="item.shortName"
			              :value="ssjgValue"
			              :label="item.name"
			              :placeholder="`点击选择` + item.name"
			              @click="showPickerSsjg = true"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            />
			            <van-popup v-model="showPickerSsjg" position="bottom">
			              <van-picker show-toolbar :columns="ssjgColumns" @confirm="onConfirmSsjg" @cancel="showPickerSsjg = false" />
			            </van-popup>
			          </div>
			          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 5 && item.shortName == 'bmtable'">
			            <van-field
			              :name="item.shortName"
			              :label="item.name"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            >
			              <template #input>
			                <van-uploader v-model="fileList" :deletable="false" accept="image/*,application/pdf" :max-size="5000 * 1024" :after-read="afterRead" />
			  
			              </template>
			            </van-field>
			            <p style="color:red; text-align: center;"><b>仅支持pdf、图片格式</b></p>
			          </div>
			          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 6 && item.shortName == 'csrq'">
			            <van-field
			              readonly
			              clickable
			              :name="item.shortName"
			              :value="dateValue"
			              :label="item.name"
			              :placeholder="`点击选择` + item.name"
			              @click="showPopup"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            />
			            <van-popup v-model:show="show" position="bottom">
			              <van-datetime-picker
			              v-model="showCalendar"
			              @confirm="onConfirmDate"
			              @cancel="onCancelDate"
			              :min-date="minDate"
			              :max-date="maxDate"
			                type="date"
			                title="选择年月日"
			              />
			            </van-popup>
			          </div>
			          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 6 && item.shortName == 'djsj'">
			            <van-field
			              readonly
			              clickable
			              :name="item.shortName"
			              :value="djsj"
			              :label="item.name"
			              :placeholder="`点击选择` + item.name"
			              @click="showPopup_djsj"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            />
			            <van-popup v-model:show="show_djsj" position="bottom">
			              <van-datetime-picker
			              v-model="showCalendar"
			              @confirm="onConfirmDate_djsj"
			              @cancel="onCancelDate"
			                :min-date="maxDate"
			                type="date"
			                title="选择年月日"
			              />
			            </van-popup>
			          </div>
			          <div class="formInput " v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 6 && item.shortName == 'fjsj'">
			            <van-field
			              readonly
			              clickable
			              :name="item.shortName"
			              :value="fjsj"
			              :label="item.name"
			              :placeholder="`点击选择` + item.name"
			              @click="showPopup_fjsj"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            />
			            <van-popup v-model:show="show_fjsj" position="bottom">
			              <van-datetime-picker
			              v-model="showCalendar"
			              @confirm="onConfirmDate_fjsj"
			              @cancel="onCancelDate"
			                :min-date="maxDate"
			                type="date"
			                title="选择年月日"
			              />
			            </van-popup>
			          </div>
			          <div class="formInput" v-else-if="item.isShow * 1 == 1 && item.formType * 1 == 4 && item.shortName == 'isBase'">
			            <van-field
			              :name="item.shortName"
			              :label="item.name"
			              :rules="[JSON.parse(item.defaultValue).rules[0] !== undefined ? JSON.parse(item.defaultValue).rules[0] : '']"
			              :required="JSON.parse(item.defaultValue).rules == '' ? false : true"
			            >
			              <template #input>
			                <van-radio-group v-model="isBaseValue" direction="horizontal">
			                  <van-radio :name="key" :key="index" v-for="(data, key, index) in JSON.parse(item.defaultValue).valueEnum">{{ data.text }}</van-radio>
			                </van-radio-group>
			              </template>
			            </van-field>
			          </div>
			          <div  style="margin:30px 16px 0; position:absolute;left:0;bottom:0;width:calc(100% - 32px)">
			            <van-button round block :disabled="disabled" type="info" native-type="submit">{{ submitBtn == -1 ? '会议已结束' : submitBtn == 0 ? '确认' : '下一步' }}</van-button>
			          </div>
			        </van-form>
			      </van-col>
			    </van-row>
			</div>
			<div v-else style="text-align: center;padding:10px 0 30px;color:#999;">暂无数据</div>
		</van-dialog>
		<van-dialog v-model:show="chmShow" theme="round-button">
		  <template #title >
		    <h4 style="margin:0 0 20px;font-size: 20px;">【{{ewmItem.name}}】参会码</h4>
		  </template>
		    <div class="chmContent">
		    <div class="product-hover"></div>
		      <img :src="ewmItem.ewmUrl" alt="" class="chmewm">
		    </div>
		    <br>
		</van-dialog>
		<van-dialog v-model="xfShow" width="100%" :show-confirm-button="false" theme="round-button" className="xfDialog">
			<template #title >
			  <h4 style="margin:0 0 20px;font-size: 20px;">学分</h4>
			</template>
			<div v-if="attr2" style="">
				<van-notice-bar style="font-size: 16px;" v-if="meeting.scoreDeadline">
				 温馨提示：学分申请截止日期{{meeting.scoreDeadline.substring(0,10)}}。
				  <template #left-icon>
				    <van-icon name='info-o' size="20" style="margin-right: 10px;" />
				  </template>
				</van-notice-bar>
			  <van-row class="bmForm"  style="padding-top:0; position: relative;">
				  
			    <van-col span="24" style="height:300px;padding-bottom:50px;overflow-y: auto;">
					
					<van-form @submit="onSubmit_xf">
						<div class="formInput hide">
						<van-field
						  v-model="attr2.enteredId"
						  :value="attr2.enteredId"
						  name="enteredId"
						/>
						</div>
			      <div class="formInput">
			        <van-field
			          v-model="attr2.name"
			          :value="attr2.name"
			          name="name"
			          placeholder="请填写姓名"
			          label="姓名"
			          clearable
			          required
			          :rules="[{ required: true, message: '请填写姓名' }]"
			        />
			      </div>
			      <div class="formInput">
			        <van-field
			          v-model="attr2.age"
					  :value="attr2.age"
			          name="age"
			          placeholder="请填写年龄"
			          label="年龄"
			          maxlength='3'
			          type="digit"
			          clearable
			          required
			          :rules="[{ required: true, message: '请填写年龄' }]"
			        />
			      </div>
			      <div class="formInput">
			        <van-field
			      			
			          name="sex"
			          label="性别"
			          required
			        >
			          <template #input>
			            <van-radio-group v-model="attr2.sex" direction="horizontal">
			              <van-radio name="男">男</van-radio>
			              <van-radio name="女">女</van-radio>
			            </van-radio-group>
			          </template>
			        </van-field>
			      </div>
			      <div class="formInput">
			        <van-field
			      			
			          v-model="attr2.titlegrade"
			          is-link
			          readonly
			          name="titlegrade"
			          label="职称"
			          placeholder="请选择职称"
			          required
			          @click="showPicker_titlegrade = true"
			          :rules="[{ required: true, message: '请选择职称' }]"
			        />
			        <van-popup v-model:show="showPicker_titlegrade" position="bottom">
			          <van-picker
			          show-toolbar
			            :columns="columns_titlegrade"
			            @confirm="onConfirm_titlegrade"
			            @cancel="showPicker_titlegrade = false"
			          />
			        </van-popup>
			      </div>
			      <div class="formInput">
			        <van-field
			      			
			          v-model="attr2.gzdw"
			          name="gzdw"
			          placeholder="请填写单位标准全称"
			          label="工作单位"
			          clearable
			          required
			          :rules="[{ required: true, message: '请填写单位标准全称' }]"
			        />
			      </div>
			      <!-- <div class="formInput">
			        <van-field
			      			
			          v-model="unitlocation"
			          name="unitlocation"
			          placeholder="请填写单位所在地"
			          label="单位所在地"
			          clearable
			          required
			          :rules="[{ required: true, message: '请填写单位所在地' }]"
			        />
			      </div> -->
			      <!-- <div class="formInput">
			        <van-field
			      			
			          v-model="titlegrade"
			          name="titlegrade"
			          placeholder="请填写职称"
			          label="职称"
			          clearable
			          required
			          :rules="[{ required: true, message: '请填写职称' }]"
			        />
			      </div> -->
			      <!-- <div class="formInput">
			        <van-field
			      			
			          v-model="department"
			          name="department"
			          placeholder="请填写科室/部门"
			          label="科室/部门"
			          clearable
			          required
			          :rules="[{ required: true, message: '请填写科室/部门' }]"
			        />
			      </div> -->
			      <div class="formInput">
			        <van-field
			      			
			          name="isbasiclevel"
			          label="是否来自基层（县及以下、社区等医疗卫生机构）"
			          required
			        >
			          <template #input>
			            <van-radio-group v-model="attr2.isbasiclevel" direction="horizontal">
			              <van-radio name="是">是</van-radio>
			              <van-radio name="否">否</van-radio>
			            </van-radio-group>
			          </template>
			        </van-field>
			      </div>
			      <div class="formInput">
			        <!-- <van-field
			      			
			          v-model="province"
			          name="province"
			          placeholder="请填写所属省市"
			          label="所属省市"
			          clearable
			          required
			          :rules="[{ required: true, message: '请填写所属省市' }]"
			        /> -->
			       
					<van-field
			          v-model="attr2.province"
			          is-link
			          readonly
					  name="province"
			          label="单位所在地（省）"
			          placeholder="请填写单位所在地（省）"
			          required
			          @click="showPicker_xf = true"
			          :rules="[{ required: true, message: '请选择单位所在地（省）' }]"
			        />
			        <van-popup v-model:show="showPicker_xf" round position="bottom">
			          <van-area title="所属省" :area-list="areaList" :columns-num="1" @confirm="onConfirmProvince_xf" @cancel="showPicker_xf = false" />
			        </van-popup>
			      </div>
			      <div class="formInput">
			        <van-field
			      				
			          v-model="attr2.phone"
			          name="phone"
			          label="联系电话"
			          placeholder="请输入联系电话"
			          type="tel"
			          clearable
			          required
			          maxlength="11"
			          :rules="[{ pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, required: true, message: '联系电话格式错误' }]"
			        />
			      </div>
			      <!-- <div class="formInput">
			        <van-field
			      			
			          name="islsxbfc"
			          label="是否隶属于西部12省（区、市）范畴"
			          required
			        >
			          <template #input>
			            <van-radio-group v-model="islsxbfc" direction="horizontal">
			              <van-radio name="是">是</van-radio>
			              <van-radio name="否">否</van-radio>
			            </van-radio-group>
			          </template>
			        </van-field>
			      </div> -->
				  <div style="margin:30px 16px 0; position:absolute;left:0;bottom:0;width:calc(100% - 32px)">
				    <van-button round block  type="info" native-type="submit">保存</van-button>
				  </div>
				  </van-form>
			      </van-col>
			  </van-row>
			</div>
			<div v-else style="text-align: center;padding:10px 0 30px;color:#999;">暂无数据</div>
		</van-dialog>
		
        <div style="margin:0 0 0; position: fixed; bottom:0;left:0;width:92%;height:100px;background-color: #fff;padding:20px 4%;">
          <van-button round block type="info" @click="xzchr">新增参会人</van-button>
		  <van-button style="margin-top: 10px;" round block type="default" @click="fhsyb">返回首页</van-button>
        </div>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import Global from '../Global/global.vue';
import { areaList } from '@vant/area-data';
export default {
  data() {
    return {
		ewmImg: require('@/assets/images/ewmImg.png'),
      meetingName: '',
      name:'',
      phone:'',
      crtTime:'',
      bmxx:'',
      dtbd:'',
	  enteredList:{},
      province:'',
      ydjd:[],
      bmtable:[],
	  chmShow:false,
	  xfShow:false,
	  lookShow:false,
	  attr2:null,
	  ewmItem:'',
	  lookItem:{},
	  dtbd:'',
	  
	  showPicker_xf:false,
	  showPicker_titlegrade:false,
	  columns_titlegrade:[
	    {
	      text: '副高及以上',
	      value:'副高及以上'
	    },
	    {
	      text:'中级',
	      value:'中级'
	    },
	    {
	      text:'初级',
	      value:'初级'
	    },
	    {
	      text:'乡村医生',
	      value:'乡村医生'
	    }
	  ],
	  
	  sqxfEndTime:"",
	  meetingId: '',
	  disabled:false,
	  formData:"",
	  submitBtn: '', //0 非审核-免费会议  1 非审核收费会议  2 审核-免费会议
	  zjlxValue: '',
	  zjlxColumns:[],
	  ssjgValue: '',
	  ssjgColumns:[],
	  provinceValue: '',
	  provinceColumns: [],
	  zzmmValue: '',
	  zzmmColumns: [],
	  nationValue: '',
	  nationColumns: [],
	  educationValue: '',
	  educationColumns: [],
	  shensValue: '',
	  showPickerZjlx: false,
	  showPicker: false,
	  showPickerShens: false,
	  showPickerZzmm: false,
	  showPickerNation: false,
	  showPickerEducation: false,
	  showPickerSsjg: false,
	  dateValue: '',
	  showCalendar: false,
	  zjlxValueEnum:[],
	  ssjgValueEnum:[],
	  valueEnum: [],
	  zzmmValueEnum: [],
	  nationValueEnum: [],
	  educationValueEnum: [],
	  meetingId: '',
	  disabled: false,
	  areaList: areaList,
	  minDate: new Date(1900, 0, 1),
	  maxDate: new Date(),
	  show:false,
	  phoneValue:"",
	  fileList:[],
	  bmtable:[],
	  ReAddressShow:false,
	  showPickerSsx:false,
	  ReAddressValue:'',
	  provinceSelect:'',
	  citySelect:'',
	  districtSelect:'',
	  //房型
	  showPickerFangxing: false,
	  fangxingValue: '',
	  fangxingColumns:[],
	  fangxingValueEnum:[],
	  //入住/离店时间
	  showRzld: false,
	  rzldValue:'',
	  rzldTime:'',
	  rzldStartTime:'',
	  rzldEndTime:'',
	  rzldMinDate: '',
	  rzldMaxDate: '',
	  show_djsj:false,
	  show_fjsj:false,
	  djsj:'',
	  fjsj:''
    };
  },
  created() {
    this.getMeetingFromInfo();
  },
  methods: {
	  fhsyb(){
	  		  this.$router.push('/personal/index');
	  },
	onConfirm_titlegrade(value) {
	  this.attr2.titlegrade = value.value;
	  this.showPicker_titlegrade = false;
	},
	onConfirmProvince_xf(value) {
	  this.attr2.province = value.map(item => item.name).join('/');
	  this.showPicker_xf = false;
	},
	onSubmit(values){
		console.log(values);
		this.lookShow = false;
	},
    toEnteredCenter() {
      var domain = window.location.host;
      //设置请求地址
      var http = "";
      if (domain.indexOf('127.0.0.1') > -1 || domain.indexOf('localhost') > -1 || domain.indexOf('meeting.ejectu.com') == 0) {
          //域名
          http = "https://meeting.ejectu.com";
      }

      const hyMeetingId = sessionStorage.getItem('meetingId');
      const token = localStorage.getItem('sessionGrzxToken_'+hyMeetingId);
      
      if (!token) {
        this.$router.push('/personal/login?meetingId=' + hyMeetingId);
        return false;
      } else {
        this.axios.get('/api/appweb/entered/toEnteredCenter/' + hyMeetingId, { headers: { Authorization: ` ${token}` } }).then(res => {
          // console.log(res.data.data);
          if(res.data.status == 200){
			  this.meeting = res.data.data.meeting;
			  this.$cookies.set('meetingName',res.data.data.meeting.meetingName)
			  if(res.data.data.enteredList){
				  this.teamOperator = res.data.data.teamOperator;
				  this.enteredList = res.data.data.enteredList;
				  this.enteredList.forEach((item)=>{
					  if(item.payDetail){
						  var enteredList = JSON.parse(item.payDetail).enteredList;
						  console.log(item);
					  	enteredList.forEach((key)=>{
							
						})
					  }
				  })
				  
			  }
			  
		  }
        });
      }
    },
    fhgrzx(){
      this.$router.push('/personal/index')
    },
	xzchr(){
		this.$router.push('/personal/member/add?meetingCode='+this.meeting.code)
	},
	//获取会议信息
	getMeetingFromInfo() {
	  var meetingCode = this.$route.query.meetingCode;
	  var html = '';
	  this.axios.get('/api/appweb/entered/getMeetingFromInfo?code=' + meetingCode).then(res => {
	    let meetingForm = res.data.data.meetingForm;
	    //入住/离店时间：报名开始前一天到报名结束日期
	    this.rzldMinDate = new Date(this.$moment(res.data.data.startTime).format('YYYY'),this.$moment(res.data.data.startTime).format('M')-1,this.$moment(res.data.data.startTime).format('D')*1-1);
	    this.rzldMaxDate = new Date(this.$moment(res.data.data.endTime).format('YYYY'),this.$moment(res.data.data.endTime).format('M')-1,this.$moment(res.data.data.endTime).format('D'));
	    sessionStorage.setItem('meetingId',res.data.data.meeting.id);
	    //免费隐藏字段：会议酒店住宿需求（牡丹港都）、抵达时间、返程时间、是否参加24日医院参观
	    if(this.$cookies.get('cookie_entret_type') == '7'&&meetingCode=='tiboltto'){
	        var meetingForm_mf = [];
	        meetingForm.forEach((v,key,index)=>{
	          if(v.shortName!="isYdjd"&&v.shortName!="djsj"&&v.shortName!="fjsj"&&v.shortName!="isVisit"){
	            meetingForm_mf.push(v)
	          }
	        })
	        meetingForm = meetingForm_mf;
	    }
	    //免费隐藏字段结束
	
	    meetingForm.forEach((item, key, index) => {
	      let valueEnum = JSON.parse(item.defaultValue).valueEnum;
	      if (item.shortName == 'zjlx') {
	        this.zjlxValueEnum = valueEnum;
	        for (var i in valueEnum) {
	          this.zjlxColumns.push(valueEnum[i].text);
	        }
	      } if (item.shortName == 'province') {
	        this.provinceValueEnum = valueEnum;
	        for (var i in valueEnum) {
	          this.provinceColumns.push(valueEnum[i].text);
	        }
	      } if (item.shortName == 'isYdjd') {
	        this.isYdjdValueEnum = valueEnum;
	        for (var i in valueEnum) {
	          this.isYdjdColumns.push(valueEnum[i].text);
	        }
	      } else if (item.shortName == 'zzmm') {
	        this.zzmmValueEnum = valueEnum;
	        for (var i in valueEnum) {
	          this.zzmmColumns.push(valueEnum[i].text);
	        }
	      } else if (item.shortName == 'nation') {
	        this.nationValueEnum = valueEnum;
	        for (var i in valueEnum) {
	          this.nationColumns.push(valueEnum[i].text);
	        }
	      } else if (item.shortName == 'education') {
	        this.educationValueEnum = valueEnum;
	        for (var i in valueEnum) {
	          this.educationColumns.push(valueEnum[i].text);
	        }
	      }else if (item.shortName == 'ssjg') {
	        this.ssjgValueEnum = valueEnum;
	        for (var i in valueEnum) {
	          this.ssjgColumns.push(valueEnum[i].text);
	        }
	      }else if (item.shortName == 'isYdjd') {
	        console.log(item);
	         item.linkage = [
	           // {
	           //   "isCommon": "1",
	           //   "shortName": "fangXing",
	           //   "name": "房型",
	           //   "isShow": "1",
	           //   "type": "CHAR",
	           //   "formType": "3",
	           //   "defaultValue": "{\"title\":\"房型\",\"dataIndex\":\"fangXing\",\"rules\":[{\"required\":true,\"message\":\"必填项\"}],\"valueEnum\":{\"单间\":{\"text\":\"单间\"},\"标间\":{\"text\":\"标间\"}},\"hideInSearch\":true}"
	           //  },
	           //  {
	           //    "isCommon": "1",
	           //    "shortName": "rzldTime",
	           //    "name": "入住/离店时间",
	           //    "isShow": "1",
	           //    "type": "dateRange",
	           //    "formType": "6",
	           //    "defaultValue": "{\"title\":\"入住/离店时间\",\"dataIndex\":\"rzldTime\",\"valueType\":\"dateRange\",\"rules\":[{\"required\":true,\"message\":\"必填项\"}],\"hideInSearch\":true}"
	           //  }
	         ];
	         var linkage = item.linkage;
	         for (var i = 0; i < linkage.length; i++) {
	           let ydjdValueEnum = JSON.parse(linkage[i].defaultValue).valueEnum;
	           if(linkage[i].shortName == 'fangXing'){
	             this.fangxingValueEnum = ydjdValueEnum;
	             for (var i in ydjdValueEnum) {
	               this.fangxingColumns.push(ydjdValueEnum[i].text);
	             }
	           }
	         }
	      }
	    });
	    this.formData = meetingForm;
		for (var i = 0; i < meetingForm.length; i++) {
			this.lookItem[meetingForm[i].shortName] ="";
		}
	  });
	},
	look(item){
		// this.$router.push('/personal/member/edit?meetingCode='+this.meeting.code+'&id='+item.id)
		this.$router.push('/personal/member/view?meetingCode='+this.meeting.code+'&id='+item.id)
		this.lookShow = true;
		this.lookItem = item;
		var extendParam = JSON.parse(item.extendParam);
		// for (let k in extendParam) {
		// 	item[k] = extendParam[k];
		// }
		this.formData.forEach((key)=>{
			for (let v in item) {
				if(key.shortName == v){
					if(key.shortName == 'province'){
						this.provinceValue = item.provinceStr;
						//this.lookItem[key.shortName] = item[v];
					}
					this.lookItem[key.shortName] = item[v];
					key[key.name] = item[v];
					key['value'] = item[v];
				}
				for (let k in extendParam) {
					// key[K] = extendParam[k];
					if(key.shortName == k){
						if(key.shortName == 'ssjg'){
							this.ssjgValue = extendParam[k];
						}
						this.lookItem[key.shortName] = extendParam[k];
						key['value'] = extendParam[k]
					}
				}
			}
			
		})
		console.log(this.lookItem);
		// console.log(this.formData);
	},
	remove(item){
		var This = this;
		This.$dialog.confirm({
		  title: '提示',
		  message: '确认是否删除该参会人信息？',
		}).then(() => {
		    // on confirm
			var data = {
				"meetingId":item.meetingId,
				"phone":item.phone
			}
			const token = localStorage.getItem('sessionGrzxToken_'+item.meetingId);
			if (!token) {
			  This.$router.push('/personal/login?meetingId=' + item.meetingId);
			  return false;
			} else {
				This.axios.post('/api/appweb/team/delEntered',data, { headers: { Authorization: ` ${token}` }}).then(res => {
					console.log(res);
					if(res.data.status == 200){
						This.$toast.success('删除成功');
						setTimeout(()=>{
							This.toEnteredCenter();
						},2000)
					}else{
						This.$toast.fail(res.data.message)
					}
				});
			}
			
		  }).catch((a) => {
			console.log(a);
		    // on cancel
			// This.$toast.fail('取消')
		  });
	},
	chm(item){
		this.ewmItem = item;
		this.chmShow = true;
	},
	xuefen(item){
		// this.attr2 = [];
		// this.xfShow = true;
		// this.attr2 = JSON.parse(item.attr2);
		// this.attr2['enteredId'] = item.id;
		this.$router.push('/personal/member/xf?enteredId='+item.id)
	},
	enteredApplyRefund(item){
		if(new Date(this.meeting.refundDeadline) <= new Date()){
			this.$dialog.alert({
				message:`<div id="loadContent" style="display:block;text-align:justify;font-size:16px; line-height:26px;text-indent:2em;"><p>MAIC 2026会议已于今日（2026年9月15日）正式开幕，报名系统自动退款通道同步关闭。如您确需办理退款，请于2026年9月21日（含）后，致电代表报名咨询电话进行人工处理。</p><p>咨询电话：010-68790162、68790710</p><p>感谢您的理解与配合。</p></div>`
			})
		}else{
			var This = this;
			const hyMeetingId = sessionStorage.getItem('meetingId');
			const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);
			this.axios.get('/api/appweb/orderDetails/fapiao/check/'+item.phone+'/'+hyMeetingId, {
				headers: {
					Authorization: ` ${token}`
				}
			}).then((res) => {
				if (res.data.status == 200) {
					this.$dialog.confirm({
						title: '操作',
						message: '您确定申请退费吗？本操作无法撤回，请谨慎操作。',
					})
					.then(() => {
						
						var data = {
							meetingId: hyMeetingId,
							enteredId: item.id
						}
						this.axios.post('/api/appweb/entered/applyRefund', data, {
							headers: {
								Authorization: ` ${token}`
							}
						}).then((res) => {
							const data = res.data.data;
							if (res.data.status == 200) {
								this.$dialog.alert({
								  message: '退费申请已提交，审核结果将通过短信发送至您。',
								}).then(() => {
								  // on close
								  This.toEnteredCenter()
								});
							}else{
								This.$toast.fail(res.data.message)
							}
						})
					})
					.catch(() => {
						// on cancel
					});
				}else{
					this.$dialog.alert({
						message:res.data.message
					})
				}
			})	
			
		}	
	},
	zhuanzeng(item){
		this.$dialog.confirm({
			title: '操作',
			message: '确定转赠您的入场票？本操作无法撤回，请谨慎操作。',
		})
		.then(() => {
			this.$router.push('/personal/applyTransfer?meetingCode=' + this.meeting.code+'&type=team&enteredId='+item.id);
		})
		.catch(() => {
			// on cancel
		});
	},
	chrConfirm(){
		var This = this;
		var item = This.lookItem;
		console.log(This.lookItem);
		const token = localStorage.getItem('sessionGrzxToken_'+item.meetingId);
		if(item.payStatus == 0){ //未支付
			if (!token) {
			  This.$router.push('/personal/login?meetingId=' + item.meetingId);
			  return false;
			} else {
				This.axios.post('/api/appweb/team/updateTeamEntered',item, { headers: { Authorization: ` ${token}` }}).then((res)=>{
					console.log(res);
					if(res.data.status == 200){
						This.$toast.success('修改成功');
						setTimeout(()=>{
							This.toEnteredCenter();
						},2000)
					}else{
						This.$toast.fail(res.data.message)
					}
				})
			}
		}	
	},
	onSubmit_xf(values) {
	  if(values.sex == ""){
	    this.$toast.fail('请选择性别')
	    return false;
	  }else if(values.titlegrade == ""){
	    this.$toast.fail('请选择职称')
	    return false;
	  }else if(values.isbasiclevel == ""){
	    this.$toast.fail('请选择是否来自基层（县及以下、社区等医疗卫生机构）')
	    return false;
	  }
	  // else if(values.islsxbfc == ""){
	  //   this.$toast.fail('请选择是否隶属于西部12省（区、市）范畴')
	  //   return false;
	  // }
	  console.log(values);
	  const hyMeetingId = sessionStorage.getItem('meetingId');
		const token = localStorage.getItem('sessionGrzxToken_'+hyMeetingId);
	   this.axios.post('/api/appweb/entered/applyCredit/'+hyMeetingId,values,{ headers: {  Authorization: ` ${token}`  } }).then((res)=>{
	     if (res.data.status == 200) {
		   this.$toast.success(res.data.data)
		   this.xfShow = false;
		   this.toEnteredCenter();
	     } else {
			this.xfShow = false;
			this.$toast.fail(res.data.message);
	     }
	   })
	},
	showPopup(){
	  this.ReAddressShow = true
	},
	showPopup_djsj(){
	  this.show_djsj = true;
	},
	showPopup_fjsj(){
	  this.show_fjsj = true;
	},
	onCancelDate(){
	  this.show = false;
	  this.show_djsj = false;
	  this.show_fjsj = false;
	},
	onConfirmDate(date) {
	  var Year = date.getFullYear();
	  var Month = date.getMonth()+1;
	  if(Month<10){
	    var Month = '0'+`${date.getMonth()+1}`;
	  }
	  var Dates = date.getDate();
	  if(Dates<10){
	    var Dates = '0'+date.getDate();
	  }
	  this.dateValue = `${Year}-${Month}-${Dates}`;
	  this.show = false;
	},
	onConfirmDate_djsj(date) {
	  var Year = date.getFullYear();
	  var Month = date.getMonth()+1;
	  if(Month<10){
	    var Month = '0'+`${date.getMonth()+1}`;
	  }
	  var Dates = date.getDate();
	  if(Dates<10){
	    var Dates = '0'+date.getDate();
	  }
	  this.djsj = `${Year}-${Month}-${Dates}`;
	  this.show_djsj = false;
	},
	onConfirmDate_fjsj(date) {
	  var Year = date.getFullYear();
	  var Month = date.getMonth()+1;
	  if(Month<10){
	    var Month = '0'+`${date.getMonth()+1}`;
	  }
	  var Dates = date.getDate();
	  if(Dates<10){
	    var Dates = '0'+date.getDate();
	  }
	  this.fjsj = `${Year}-${Month}-${Dates}`;
	  this.show_fjsj = false;
	},
	onConfirmZjlx(value) {
	  this.zjlxValue = value;
	  this.showPickerZjlx = false;
	},
	onConfirmSsjg(value) {
	  this.ssjgValue = value;
	  this.showPickerSsjg = false;
	},
	onConfirmProvince(value) {
	  this.provinceValue = value;
	  this.showPicker = false;
	},
	onConfirmZzmm(value) {
	  this.zzmmValue = value;
	  this.showPickerZzmm = false;
	},
	onConfirmNation(value) {
	  this.nationValue = value;
	  this.showPickerNation = false;
	},
	onConfirmEducation(value) {
	  this.educationValue = value;
	  this.showPickerEducation = false;
	},
	onConfirmShens(value) {
	  // console.log(this.shensValue);
	  this.shensValue = value.map(item => item.name).join('/');
	  this.showPickerShens = false;
	},
	//房型
	onConfirmFangxing(value) {
	  this.fangxingValue = value;
	  this.showPickerFangxing = false;
	},
	//是否入住酒店
	onConfirmIsYdjd(value) {
	  this.isYdjdValue = value;
	  this.showPicker_isYdjd = false;
	},
	//入住离店时间
	onConfirmRzldDate(date) {
	  this.showRzld = false;
	  const [start, end] = date;
	  this.rzldTime = `${this.$moment(start).format('YYYY-MM-DD')} 至 ${this.$moment(end).format('YYYY-MM-DD')}`;
	  this.rzldStartTime = this.$moment(start).format('YYYY-MM-DD');
	  this.rzldEndTime = this.$moment(end).format('YYYY-MM-DD');
	},
	onClickLeft() {
	  this.$router.go(-1); //返回上一层
	},
  },
  mounted(){
    this.toEnteredCenter();
  }
};
</script>

<style scoped="scoped">
.bmForm {
  padding: 20px 0;
}
.bmTitle {
  padding: 0px 20px 10px;
  line-height: 40px;
  background: url(~@/assets/images/titlebg.png) no-repeat bottom center;
  background-size: 100% 100%;
  color: #fff;
  text-align: center;
}
.bmTitle h2 {
  font-weight: normal;
  font-size: 30px;
}
.formInput {
  padding: 4px 0;
  margin: 0 20px;
  border-bottom: 1px solid #e8e8e8;
}
.lineddd {
  height: 3px;
  background-color: #e8e8e8;
  margin-top: -1px;
}
.van-cell,
.van-button {
  font-size: 16px;
}
.van-cell::after {
  border-bottom: 0;
}
.chmContent{
    position: relative;
    padding: 5px;
    width: 210px;
    margin: 20px auto 0;
}
.chmContent .chmewm{
    position: relative;
    padding: 4px;
    background: #fff;
    width:202px;
}
.product-hover{
	position:absolute;
	top:0;
	left:0;
	right:0;
	bottom:0;
	-webkit-transition:opacity 0.3s ease;
	-moz-transition:opacity 0.3s ease;
	transition:opacity 0.3s ease;
	background-size:30px 30px;
	background-image:-webkit-linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
	background-image:-moz-linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
	background-image:linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
	-webkit-animation:barberpole 0.5s linear infinite;
	-moz-animation:barberpole 0.5s linear infinite;
	animation:barberpole 0.5s linear infinite;
}
@-webkit-keyframes barberpole{
	from{
		background-position:0 0;
	}
	to{
		background-position:60px 30px;
	}
}

@-moz-keyframes barberpole{
	from{
		background-position:0 0;
	}
	to{
		background-position:60px 30px;
	}
}

@keyframes barberpole{
	from{
		background-position:0 0;
	}
	to{
		background-position:60px 30px;
	}
}
.hide {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/Personal/teammember.vue